/*eslint-disable */

import DashSidebar from '@/components/private/common/dashboard-left-sidebar/';
import Push from 'push.js';
import acknowledgementPopup from '@/components/private/user/user-acknowledgement-popup/';
import adapter from 'webrtc-adapter';
import {
  bus
} from '@/main';
import chatbot from '@/components/private/user/user-chatbot/';
import commonSocket from '@/commonSocket/index.js';
import {
  mapGetters
} from 'vuex';
import moment from 'moment';
import teamMemberAccept from '@/components/private/team/team-member-request-accept-popup/';
import videoCallNotification from '@/components/private/video-call-notification-popup/';
import videoSocketRef from "@/videoNotificationSocket";

const $ = window.jQuery = require('jquery');
var schedulerPushNotification;
export default {
  name: 'dashboard',
  components: {
    'user-chatbot' : chatbot,
    'dash-sidebar' : DashSidebar,
    'video-call' : videoCallNotification,
    'acknowledgement-popup':acknowledgementPopup,
    'team-member-accept' : teamMemberAccept
  },
  props: [],
  data () {
    return {
      userDetails:null,
      soketForSelfUserId:'',
      incomingCallNotification:false,
      callerName:'',
      hasWebrtcSupport: true,
      isClosed: true,
      currentUserId: null,
      userAcknowledgement:false,
      videoCallerUserId:'',
      teamMemberAcceptState:false,
      requestMemberInfo:null,
      isMobile:false,
      audioPlayer:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
  getUserDetailsAgainFun(){
    this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
    return
  },
  setIntialStates(){
    if(this.userDetails){
      this.soketForSelfUserId = this.userDetails.id
      if(this.userDetails.added_by_user && this.userDetails.added_by_user.first_name){
        if(this.userDetails.sub_user_accepted == false){
          this.teamMemberAcceptState = true
          this.requestMemberInfo = this.userDetails.added_by_user
          $('body').addClass('body_right_scroll_remove')
        }
      }
    }
    return
  }
  },
  mounted () {
    this.currentUserId = localStorage.getItem('LoginedUserID');
    if(localStorage.getItem('LoginedUserID'))
    if(sessionStorage.getItem('isClosed')) {
      this.isClosed = sessionStorage.getItem("isClosed");
    } else {
      this.isClosed = false;
    }
    if (!localStorage.getItem('token')) {
      this.$router.push('/');
    }
    this.$store.dispatch('getAuthHeader');
    this.getUserDetailsAgainFun
    this.setIntialStates
    bus.$emit('showHeaderbtn', true);
    $(".preloader").delay(200).fadeOut("slow");
    setTimeout(() => {
    if(localStorage.getItem('token') && this.$route.name != 'videoChat'  && this.$route.name != 'videoChatOneToOnePeer' && this.$route.name != 'red5'  && this.$route.name != 'videoCallOneToOnePeer'){
      this.commonSocketConnectMethod();
      this.videoNotficationAlertPopupForSocket();
    }
    }, 800);
    bus.$on('callerNotifiactionBus', (data) => {
      this.incomingCallNotification = data;
    });
    if(this.hasUserMedia() && this.hasRTCPeerConnection()) {
      let safariVersion = 0;
      if(adapter.browserDetails.browser === 'safari') {
        safariVersion = this.getBrowserVersion()
      }
      // console.log(`Browser ${adapter.browserDetails.browser} - version ${adapter.browserDetails.version}`);
      if((adapter.browserDetails.browser == "chrome" && adapter.browserDetails.version > 50) || (adapter.browserDetails.browser == "firefox" && adapter.browserDetails.version > 45) || (adapter.browserDetails.browser == "safari" && safariVersion > 11) ) {
        this.hasWebrtcSupport = true;
       } else {
        this.hasWebrtcSupport = false;
      }
    } else {
      this.hasWebrtcSupport = false;
    }

    bus.$on('sendRequestMessage', (data) => {
      const payload = {
        message: "Friend Request",
        type: "friendRequest",
        userID: data.to_user,
        fromUserID: data.from_user,
        second_user_id:data.to_user,
      };
      videoSocketRef.emit(payload);
    });
    bus.$on('newChatMessage', (data) => {
      const payload = {
        type: "newChatMessage",
        message: "New Chat Message",
        fromUserID: data.fromUserID,
        toUserID: data.toUserID,
        second_user_id:data.toUserID,
        chatRoomId: data.chatRoomId,
        senderMsgData:data.senderMsgData,
        msgSenderFullName:data.msgSenderFullName
      };
      videoSocketRef.emit(payload);
    });
    bus.$on('newChatMessageOfGroupRoom', (data) => {
      const payload = {
        type: "newChatMessageOfGroupRoom",
        message: "New Chat Message Of Group Room",
        selfUserID: data.selfUserID,
        chatRoomId: data.chatRoomId,
        second_user_id:data.chatRoomId,
        senderMsgData:data.senderMsgData,
        msgSenderFullName:data.msgSenderFullName
      };
      videoSocketRef.emit(payload);
    });
    this.setPushNotificationForSchedulerMethod()
    schedulerPushNotification = setInterval(() => {
      this.setPushNotificationForSchedulerMethod()
    },1560000)
    bus.$on('requestMemberAcceptStateBus', (data) => {
      this.teamMemberAcceptState = data
    });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 769
    },
    schedulerIsReadStatusUpdateMethod(schedulerId){
      var data = {
        is_read:true
      }
      this.$store.dispatch('updateSchedulerDetailsAction', {data:{data:data,id:schedulerId}})
    },
    setPushNotificationForSchedulerMethod(){
      var __self = this
      var currentTime = new Date();
      var utcDate = new Date().toJSON().slice(0,10).replace(/-/g,'-');
      var utcTime = currentTime.getHours() + ":" + currentTime.getMinutes() + ":" + currentTime.getSeconds();
      var datetime = utcDate + ' ' + utcTime;
      this.$store.dispatch('getSchedulerListByDateAction', {Date:datetime}).then((res) => {
        if(res.data.data.length === 0) return;
        var joinStartTime = res.data.data[0].StartTime 
        var startTimeHours = moment(joinStartTime).format('HH')
        var startTimeCheck = moment(joinStartTime).format('mm:ss')
        var currentLocalHours = moment().format('HH')
        var currentLocalTime = moment().format('mm:ss')
        var totalMinutesOfStartMeeting  = startTimeHours*parseInt(60) + parseInt(startTimeCheck)
        var totalMinutesOfCurrent  = currentLocalHours*parseInt(60) + parseInt(currentLocalTime);
        if(totalMinutesOfStartMeeting > totalMinutesOfCurrent){
          var validTime = totalMinutesOfStartMeeting - totalMinutesOfCurrent
          if(parseInt(30) > validTime){
            if(Push.Permission.has()){
              // Push.create(res.data.data[0].Subject, {
              //   body:'Check Your Lymphomap To Scheduler',
              //   timeout:5000,
              //   onClick: function () {
              //       window.focus();
              //       this.close();
              //       __self.schedulerIsReadStatusUpdateMethod(res.data.data[0].Id);
              //   }
              // })
            }
          }
        }
      })
    },
    getBrowserVersion() {
        var ua= navigator.userAgent, tem,
        M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1] || '');
        }
        if(M[1]=== 'Chrome'){
            tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
            if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
        }
        M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
        return M[1];
    },
    closeModal() {
      sessionStorage.setItem("isClosed", true);
      this.isClosed = true;
    },
    /*
    * this will check if user has getUserMedia
    */
    hasUserMedia() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      return !!navigator.getUserMedia;
    },
    /*
    * this will check that user browser supports webrtc or not
    */
    hasRTCPeerConnection() {
      window.RTCPeerConnection = window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection;
      window.RTCSessionDescription = window.RTCSessionDescription || window.webkitRTCSessionDescription || window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.RTCIceCandidate || window.webkitRTCIceCandidate || window.mozRTCIceCandidate;
      return !!window.RTCPeerConnection;
    },
    playSound (sound) {
      if(sound) {
        this.audioPlayer = new Audio(sound);
        this.audioPlayer.play();
      }
    },
    stopSound () {
      if(this.audioPlayer == null) return;  
      this.audioPlayer.muted = true;
      this.audioPlayer.pause();
      this.audioPlayer.currentTime = 0;
      this.audioPlayer = null
    },
    commonSocketConnectMethod(){
      let callerID = '3548d149becb44e9';
      commonSocket.connect(callerID);
      commonSocket.$on('connection', response => {
        const payload = {
          type: "userLogin",
          userID: this.currentUserId,
          message: "User Login",
          second_user_id:''
        };
        commonSocket.emit(payload);
      });
      commonSocket.$on('userLogin', this.handleUserLogin);
      commonSocket.$on('userLogout', this.handleSelfUserLogoutStatus);
      commonSocket.$on('userLogin', this.handleSelfUserStatus);
      commonSocket.$on('selfUserStatus', this.handleAllUserStatus);
      commonSocket.$on('userLogout', this.handleUserLogout);
    },
    videoNotficationAlertPopupForSocket(){
      this.$store.dispatch('roomCreateIdforGlobalSocketMethod').then((res) => {
        let callerID = res.data.data.val;
        videoSocketRef.connect(callerID);
        videoSocketRef.$on('videoCallingNotification', this.getVideoNotificationMsg);
        videoSocketRef.$on('videoCallAlertPopupClosed', this.callerPopupClosedInOtherTabs);
        videoSocketRef.$on('friendRequest', this.handleFriendRequest);
        videoSocketRef.$on('newMessageNotification', this.handleNewMessageNotification);
        videoSocketRef.$on('newChatMessageOfGroupRoomNotification', this.handleNewMessageOfGroupRoomNotification);
        videoSocketRef.$on('messageIndicationForChatNotification', this.handlemessageIndicationForChatNotification);
        videoSocketRef.$on('TypingEventForSelectedUserNotification', this.handleTypingEventForSelectedUserNotification);
        videoSocketRef.$on('TypingEventForSelectedGroupNotification', this.handleTypingEventForSelectedGroupNotification);
        videoSocketRef.$on('messageDeleteForChatOfAllNotification', this.handleMessageDeleteForChatOfAllNotification);
        videoSocketRef.$on('messageForwardedOfUsersNotification', this.handleMessageForwardedOfUsersNotification);
        videoSocketRef.$on('newSupportMessageNotification', this.handlNewSupportMessageNotification);
      })
    },
    handlNewSupportMessageNotification(response) {
      const toUserID = response.toUserID;
      if(toUserID != this.currentUserId) return;
      try {
        const payload = {
          unreadCount: response.totalUnreadCount,
        };
        bus.$emit('supportMessageCountNotificationBus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleMessageForwardedOfUsersNotification(response) {
      const toUserID = response.toUserID;
      if(toUserID == this.currentUserId) return;
      try {
        const payload = {
          chat_data: response.chat_data,
          toUserID: response.toUserID,
          targetUsersID:response.targetUsersID,
          colour:response.colour,
          message_id_arr:response.message_id_arr,
        };
        bus.$emit('forwardedMessageNotifications', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleNewMessageNotification(response) {
      const toUserID = response.toUserID;
      const fromUserID = response.fromUserID;
      if(fromUserID == this.currentUserId || toUserID != this.currentUserId) return;
      try {
        const payload = {
          chatRoomId: response.chatRoomId,
          toUserID: response.toUserID,
          fromUserID: response.fromUserID,
          unreadCount: response.unreadCount,
          totalUnreadCount: response.totalUnreadCount,
          senderMsgData:response.senderMsgData,
          msgSenderFullName:response.msgSenderFullName,
          lbilWorkspace:response.lbilWorkspace || 'no'
        };
        bus.$emit('updateMessageNotification', payload);
        bus.$emit('updateMessageNotifications', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleNewMessageOfGroupRoomNotification(response) {
      const toUserID = response.selfUserID;
      if(toUserID == this.currentUserId) return;
      for(var i = 0; i < response.ingroupusers.length; i++){
        if(response.ingroupusers[i] == this.currentUserId){
          try {
            const payload = {
              selfUserID: response.selfUserID,
              chatRoomId: response.chatRoomId,
              unreadCount: response.unreadCount,
              totalUnreadCount: response.totalUnreadCount,
              senderMsgData:response.senderMsgData,
              msgSenderFullName:response.msgSenderFullName
            };
            bus.$emit('updateMessageNotificationOfGroupRoom', payload);
            bus.$emit('updateMessageNotifications', payload);
          } catch(e) {
            console.log(e);
          }
        }
      }
    },
    getVideoNotificationMsg(getData){
      if(this.soketForSelfUserId == getData.targetId){
        if(Push.Permission.has()){
          Push.create('Lymphomap Video Call From ' + getData.displayName, {
            body:'Check Your lymphomap to answer',
            timeout:5000,
            onClick: function () {
                window.focus();
                this.close();
            }
          })
        }
        $('body').addClass('videoNotificationPopup')
        this.callerName = getData.displayName
        this.videoCallerUserId = getData.callerID
        this.incomingCallNotification = true
        // this.playSound(audioPlay)
      }
    },
    callerPopupClosedInOtherTabs(closeOtherTabData){
      if(this.soketForSelfUserId != closeOtherTabData.videoCallRoomId) return;
      if(closeOtherTabData.type == 'videoAlertPopupClose'){
        this.stopSound()
        $('body').removeClass('videoNotificationPopup')
        this.callerName = ''
        this.incomingCallNotification = false
      }
    },
    closeSocket() {
      if(commonSocket.isOpen()) {
        commonSocket.close();
      }
      if(videoSocketRef.isOpen()) {
        videoSocketRef.close();
      }
    },
    handleFriendRequest(response) {
      const userID = response.userID;
      const fromUserID = response.fromUserID;
      if(fromUserID == this.currentUserId || userID != this.currentUserId) return;
      try {
        const payload = {
          userID
        };
        bus.$emit('userFriendRequest', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogout(response) {
      const userID = response.userID;
      if(userID == this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleSelfUserLogoutStatus(response) {
      const userID = response.userID;
      if(userID != this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          is_online: false,
        };
        bus.$emit('selfUserUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleUserLogin(response) {
      const userID = response.userID;
      if(userID == this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('userUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handleSelfUserStatus(response) {
      const userID = response.userID;
      if(userID != this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          is_online: true,
        };
        bus.$emit('selfUserUpdateStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
    handlemessageIndicationForChatNotification(response){
      const suserID = response.selfUserID;
      if(suserID == this.currentUserId) return;
      const userID = response.targetForChatUserId;
      if(userID == this.currentUserId){
        bus.$emit('msgIndicationStateBus', response);
      }else{
        if(response.ingroupusers){
          for(var i = 0; i < response.ingroupusers.length; i++){
            if(response.ingroupusers[i].user.id == this.currentUserId){
              bus.$emit('msgIndicationStateBus', response);
            }
          }
        }else{
          bus.$emit('msgIndicationStateBus', false);
        }
      }
    },
    handleTypingEventForSelectedUserNotification(response){
      const suserID = response.selfUserID;
      if(suserID == this.currentUserId) return;
      const userID = response.targetForChatUserId;
      if(userID == this.currentUserId){
        bus.$emit('TypingEventForSelectedUserBus', response);
      }
    },
    handleTypingEventForSelectedGroupNotification(response){
      const toUserID = response.selfUserID;
      if(toUserID == this.currentUserId) return;
      if(response.message == 'typing'){
        if(!response.ingroupuser) return;
        for(var i = 0; i < response.ingroupuser.length; i++){
          if(response.ingroupuser[i].user.id == this.currentUserId){
            bus.$emit('TypingEventForSelectedGroupBus', response);;
          }
          if(response.ingroupuser[i].user.id == toUserID){
            bus.$emit('getUserInfoTypingEventForSelectedGroupBus', response.ingroupuser[i].user);
          }
        }
      }else{
        bus.$emit('TypingEventForSelectedGroupBus', response);
      }
    },
    handleMessageDeleteForChatOfAllNotification(response){
      const toUserID = response.selfUserID;
      if(toUserID == this.currentUserId) return;
      bus.$emit('MessageDeleteForChatOfAllNotification', response);
    },
    handleAllUserStatus(response) {
      const userID = response.userID;
      if(userID == this.currentUserId) return;
      try {
        const payload = {
          userID: response.userID,
          current_status:response.current_status,
          status_time:response.status_time
        };
        bus.$emit('userSelfStatus', payload);
      } catch(e) {
        console.log(e);
      }
    },
  },
  watch:{
    getUserDetailsAgainFun(){
      return this.$store.getters.acUserDetailsStateGetters.data
    },
    setIntialStates(){
      if(this.userDetails){
        this.soketForSelfUserId = this.userDetails.id
      }
      return
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.closeSocket)
  },
  beforeDestroy() {
    if(commonSocket.isOpen()) {
      commonSocket.close();
    }
    if(videoSocketRef.isOpen()) {
      videoSocketRef.close();
    }
    window.removeEventListener("beforeunload", this.closeSocket);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  created () {
    window.addEventListener('resize', this.onResize, { passive: true })
    this.onResize()
  },
  beforeCreate: function() {
    $('body').addClass('dashboard')
    $('body').addClass('sidebar_collapsed')
    $('body').removeClass('videoNotificationPopup')
  },
  beforeRouteLeave: function(to, from, next) {
    this.stopSound()
    $('body').removeClass('dashboard')
    $('body').removeClass('videoNotificationPopup')
    clearInterval(schedulerPushNotification)
    next();
  },
}
